import { NodeViewContent, NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import cx from 'classnames';
import {
  HighlightBlockAlignment,
  HighlightBlockColor,
} from 'components/learning-center/assignments/slides/blocks/RichTextBlock/extensions';
import { DropdownMenu, ISelectOption } from 'components/ui';
import { MinusCircle } from 'ethena-icons';
import _ from 'lodash';
import { FaAlignCenter, FaAlignLeft, FaAlignRight } from 'react-icons/fa';
import css from './HighlightBlockNodeView.module.scss';

export const HighlightBlockNodeView = (props: NodeViewProps) => {
  const alignment: HighlightBlockAlignment = props.node.attrs.alignment;
  const color: HighlightBlockColor = props.node.attrs.color;

  const setAlignment = (alignment: HighlightBlockAlignment) => {
    props.updateAttributes({ alignment });
  };

  const setColor = (color: HighlightBlockColor) => {
    props.updateAttributes({ color });
  };

  const deleteBlock = () => {
    props.deleteNode();
  };

  const colorOptions: ISelectOption<HighlightBlockColor>[] = _.map(
    HighlightBlockColor,
    (color) => ({
      label: _.startCase(color),
      value: color,
    })
  );

  const selectedColorOption = _.find(
    colorOptions,
    (option) => option.value === color
  );

  return (
    <NodeViewWrapper className={cx(css.wrapper, color)}>
      <div className={css.topControls}>
        <DropdownMenu>
          <DropdownMenu.Toggle>
            <div
              className={cx(
                css.color,
                css.colorLabelCircle,
                selectedColorOption?.value
              )}
            />
            {selectedColorOption?.label}
          </DropdownMenu.Toggle>
          <DropdownMenu.Options
            aria-label="Color selection menu"
            className={css.menuSelectOptions}
          >
            {_.map(colorOptions, (option) => (
              <DropdownMenu.Option
                key={option.value}
                className={css.menuSelectOption}
                onClick={() => setColor(option.value)}
              >
                <div
                  className={cx(css.color, css.colorLabelCircle, option.value)}
                />
                {option.label}
              </DropdownMenu.Option>
            ))}
          </DropdownMenu.Options>
        </DropdownMenu>
        <div className={css.alignmentButtons}>
          <button
            className={cx(css.menuButton, {
              [css.selected]: alignment === HighlightBlockAlignment.LEFT,
            })}
            onClick={() => setAlignment(HighlightBlockAlignment.LEFT)}
          >
            <FaAlignLeft />
          </button>
          <button
            className={cx(css.menuButton, {
              [css.selected]: alignment === HighlightBlockAlignment.CENTER,
            })}
            onClick={() => setAlignment(HighlightBlockAlignment.CENTER)}
          >
            <FaAlignCenter />
          </button>
          <button
            className={cx(css.menuButton, {
              [css.selected]: alignment === HighlightBlockAlignment.RIGHT,
            })}
            onClick={() => setAlignment(HighlightBlockAlignment.RIGHT)}
          >
            <FaAlignRight />
          </button>
        </div>
        <button
          className={cx(css.menuButton, css.deleteButton)}
          onClick={deleteBlock}
        >
          <MinusCircle height={16} width={16} />
        </button>
      </div>
      <NodeViewContent
        className={css.content}
        style={{ textAlign: alignment }}
      />
    </NodeViewWrapper>
  );
};
